import get from 'lodash/get';

export const RX_MATCH_INTERPOLATE_CONTENT = /\${{?(.*?)}}?/gi;

/**
 * Replaces occurrences of ES6 template literals within `templateString` with the corresponding data
 * from `templateVariables`. Object paths may be used. JavaScript expressions are not supported by design.
 * Template and data is decoded for XSS injections.
 * 
 * @param templateString the template string
 * @param templateVariables the data context to resolve from
 * @param decodeFn Function to strip content in the initial template string
 * .defaults to use DOMParser. override this for mocking purposes when testing in node environment
 * @param valueEncoder Function to modify or encode each interpolated value.
 */
export const compile = (
  templateString: string, 
  templateVariables: { [k:string]: object | number | string | boolean}, 
  valueEncoder = (x:string)=>x
) => 
  
  !!templateString 
    ? 
      templateString.replace( RX_MATCH_INTERPOLATE_CONTENT,  ( _, capturedIdentifier ) => {
        const value = get(templateVariables, capturedIdentifier); 
        return value ? valueEncoder(value as string) : '${' + capturedIdentifier + '}' ;
       } 
      )  
    : undefined;

/**
 * Replaces occurrences of ES6 template literals within `templateString` with the value
 * returned from the `replacer` function. The `replacer` is invoked once for every template literal occurence.
 * 
 * Template and replacer return values are decoded for XSS injections.
 * 
 * @param templateString the template string
 * @param replacer function called for each template literal found. The return value will be the replacement value.
 * @param decodeFn defaults to use DOMParser. override this for mocking purposes when testing in node environment
 */
export const compileEach = (templateString: string, replacer: (capturedIdentifier:string) => string) =>  
  !!templateString ? 
    templateString.replace( RX_MATCH_INTERPOLATE_CONTENT, 
       (_, capturedIdentifier) => replacer(capturedIdentifier))
  : undefined;
